import script from "./ContactInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactInfo.vue?vue&type=script&setup=true&lang=js"

import "./ContactInfo.vue?vue&type=style&index=0&id=21705560&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21705560"]])

export default __exports__